<template>
    <div class="flex flex-col mt-5">
        <div>
            <button
                type="button"
                @click="showCreateForm = !showCreateForm"
                class="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
                <svg
                    class="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path
                        fill-rule="evenodd"
                        d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                        clip-rule="evenodd"
                    />
                </svg>
            </button>
        </div>
        <SlideOver :show="showCreateForm" @close="showCreateForm = false">
            <form action="" @submit.prevent="addMaterial()" id="new_material_form">
                <div>
                    {{ $tc('messages.materials', 1) }}
                </div>
                <input
                    type="text"
                    required
                    v-model.trim="form.title"
                    class="w-full border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                />

                <div>
                    {{ $tc('messages.links', 1) }}
                </div>
                <input
                    type="text"
                    :placeholder="$t('messages.(optional)')"
                    v-model.trim="form.url"
                    class="w-full border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                />

                <div class="mt-1">
                    <label>
                        <input
                            name="selected"
                            v-model="form.visible_by_students"
                            id="visible_by_students"
                            type="checkbox"
                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        />
                        {{ $t('messages.visible_by_students') }}
                    </label>
                </div>

                <input
                    type="hidden"
                    v-model="form.id"
                    class="border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                />
            </form>

            <div class="flex space-x-2 flex-wrap items-center mt-3">
                <AppButton
                    @click="another = false"
                    element="button"
                    type="submit"
                    form="new_material_form"
                    desired-action
                >
                    {{ $t('messages.add') }}
                </AppButton>

                <AppButton @click="another = true" element="button" type="submit" form="new_material_form">
                    {{ $t('messages.add_and_another') }}
                </AppButton>
            </div>
        </SlideOver>
        <SlideOver :show="showEditForm !== false" @close="closeEditForm()">
            <div v-if="editMaterial">
                <div>
                    {{ $tc('messages.materials', 1) }}
                </div>
                <input
                    type="text"
                    required
                    v-model.trim="editMaterial.title"
                    class="w-full border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                />

                <div>
                    {{ $tc('messages.links', 1) }}
                </div>
                <input
                    type="text"
                    :placeholder="$t('messages.(optional)')"
                    v-model.trim="editMaterial.url"
                    class="w-full border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                />

                <div class="mt-1">
                    <label>
                        <input
                            name="selected"
                            v-model="editMaterial.visible_by_students"
                            id="visible_by_students"
                            type="checkbox"
                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        />
                        {{ $t('messages.visible_by_students') }}
                    </label>
                </div>

                <AppButton desired-action element="button" type="button" @click="closeEditForm()" class="mt-3">
                    {{ $t('messages.close') }}
                </AppButton>
            </div>
        </SlideOver>

        <ul class="">
            <li v-for="(row, index) in rows" :key="index">
                <div class="flex space-x-2 items-center mt-1">
                    <span v-if="!row.url">
                        {{ row.title }}
                    </span>
                    <a :href="row.url" target="_blank" class="text-indigo-500" v-else>
                        <svg
                            class="w-4 h-4 inline-block"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
                            ></path>
                            <path
                                d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"
                            ></path>
                        </svg>
                        <span class="truncate text-ellipsis overflow-hidden">
                            {{ row.title ? row.title : row.url }}
                        </span>
                    </a>
                    <input
                        type="hidden"
                        :name="`materials[${index}][title]`"
                        v-model.trim="row.title"
                        class="w-full border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                    />
                    <input
                        type="hidden"
                        :name="`materials[${index}][url]`"
                        required
                        v-model.trim="row.url"
                        class="border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                    />
                    <input
                        type="hidden"
                        :name="`materials[${index}][id]`"
                        required
                        v-model="row.id"
                        class="border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm"
                    />
                    <button
                        type="button"
                        class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        <svg
                            class="w-4 h-4"
                            v-if="row.visible_by_students"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M10 12a2 2 0 100-4 2 2 0 000 4z"></path>
                            <path
                                fill-rule="evenodd"
                                d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                                clip-rule="evenodd"
                            ></path>
                        </svg>
                        <svg
                            class="w-4 h-4"
                            v-else
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z"
                                clip-rule="evenodd"
                            ></path>
                            <path
                                d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"
                            ></path>
                        </svg>
                    </button>
                    <button
                        type="button"
                        @click="edit(row)"
                        class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                            ></path>
                        </svg>
                    </button>
                    <button
                        type="button"
                        @click="deleteRow(index)"
                        class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        <svg viewBox="0 0 20 20" fill="currentColor" class="trash w-4 h-4">
                            <path
                                fill-rule="evenodd"
                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                clip-rule="evenodd"
                            ></path>
                        </svg>
                    </button>
                </div>
                <FormError :value="errors[`materials.${index}.title`]" class="mt-2 max-w-sm" />
                <FormError :value="errors[`materials.${index}.url`]" class="mt-2 max-w-sm" />
            </li>
        </ul>
    </div>
</template>

<script>
import AppButton from '@/components/AppButton.vue';
import SlideOver from '@/components/SlideOver.vue';
import FormError from '@/components/Forms/FormError.vue';

export default {
    emits: ['update:modelValue'],
    components: {
        FormError,
        AppButton,
        SlideOver,
    },
    data() {
        return {
            another: false,
            editMaterial: null,
            rows: this.modelValue,
            showCreateForm: false,
            showEditForm: false,
            form: {
                id: null,
                title: '',
                url: '',
                visible_by_students: false,
            },
        };
    },
    watch: {
        rows(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
    props: {
        modelValue: {
            type: Array,
            required: false,
            default: () => [],
        },
        errors: {
            required: false,
            type: Object,
        },
    },
    methods: {
        edit(row) {
            this.editMaterial = row;
            this.showEditForm = true;
        },
        closeEditForm() {
            this.showEditForm = false;
            this.editMaterial = null;
        },
        addRow() {
            this.rows.push({
                id: null,
                title: '',
                url: '',
                visible_by_students: false,
            });
        },
        addMaterial() {
            this.rows.push({
                id: this.form.id,
                title: this.form.title,
                url: this.form.url,
                visible_by_students: this.form.visible_by_students,
            });
            this.form = {
                id: null,
                title: '',
                url: '',
                visible_by_students: false,
            };

            if (this.another === false) {
                this.showCreateForm = false;
            }
        },
        deleteRow(index) {
            this.rows.splice(index, 1);
        },
    },
};
</script>
